import { push } from "connected-react-router";

import {
  getQuestionInfo,
  deleteQuestion,
  sortQuestions,
  changeQuestionVisibility
} from '../../request';

import { checkAndRenewTokens, checkTokenError } from "./auth";
import { showErrorMessage, showSuccessMessage, closeDeleteQuestionModal } from "./ui";

//Загрузка информации о вопросе
export const QUESTION_INFO_LOADING_START = "Question info loading start";
export const QUESTION_INFO_LOADED_SUCCESSFULLY = "Question info loaded successfully";
export const QUESTION_INFO_LOADING_FAILED = "Failure during question info load";

//Удаление вопроса
export const QUESTION_DELETION_START = "Question deletion start";
export const QUESTION_DELETED_SUCCESSFULLY = "Question deleted successfully";
export const QUESTION_DELETION_FAILED = "Failure during question deletion";

//Изменение видимости родительского вопроса
export const QUESTION_VISIBILITY_CHANGE_START = "Question visibility change start";
export const QUESTION_VISIBILITY_CHANGED_SUCCESSFULLY = "Question visibility changed successfully";
export const QUESTION_VISIBILITY_CHANGE_FAILED = "Failure during question visibility change";

//Изменение видимости подвопроса
export const SUBQUESTION_VISIBILITY_CHANGE_START = "Subquestion visibility change start";
export const SUBQUESTION_VISIBILITY_CHANGED_SUCCESSFULLY = "Subquestion visibility changed successfully";
export const SUBQUESTION_VISIBILITY_CHANGE_FAILED = "Failure during subquestion visibility change";

//Перемещение подвопроса по списку
export const CHILDREN_SORTING_START = "Children sorting start";
export const CHILDREN_SORTED_SUCCESSFULLY = "Children sorted successfully";
export const CHILDREN_SORTING_FAILED = "Children sorting failed";

const startLoading = () => ({
  type: QUESTION_INFO_LOADING_START 
});

const loadSuccess = question => ({
  type: QUESTION_INFO_LOADED_SUCCESSFULLY,
  payload: {
    question: question || {}
  }
});

const loadFailure = () => ({
  type: QUESTION_INFO_LOADING_FAILED,
});

//ЗАГРУЗКА ИНФОРМАЦИИ О ВОПРОСЕ
export const getQuestionInfoAsync = questionId => { 
  return async (dispatch) => {
    dispatch(startLoading());
    await dispatch(checkAndRenewTokens());
    let question;
    const accessToken = localStorage.getItem("accessToken");
    try {
      question = await getQuestionInfo(accessToken, questionId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при загрузке вопроса!"));
      return dispatch(loadFailure());
    }
    return dispatch(loadSuccess(question));
  };
};

//УДАЛЕНИЕ ВОПРОСА
const startDeletion = () => ({
  type: QUESTION_DELETION_START
});

const deletionSuccess = () => ({
  type: QUESTION_DELETED_SUCCESSFULLY,
});

const deletionFailure = () => ({
  type: QUESTION_DELETION_FAILED,
});

export const deleteQuestionAsync = questionId => { 
  return async (dispatch, getState) => {
    dispatch(startDeletion());
    await dispatch(checkAndRenewTokens()); 
    //const data = { is_visible: status };
    //Получим название вопроса
    const currentState = getState();
    const questionName = currentState.questionInfo.question.header;
    try {
      const accessToken = localStorage.getItem("accessToken");
      //await changeQuestionVisibility(accessToken, data, questionId);
      await deleteQuestion(accessToken, questionId);
    } catch (err) {
      dispatch(checkTokenError(err));
      dispatch(showErrorMessage("Ошибка при удалении вопроса"));
      return dispatch(deletionFailure());
    }
    dispatch(push('/questions'));
    dispatch(closeDeleteQuestionModal());
    const msgText = `Вопрос ${questionName} удален`;
    dispatch(showSuccessMessage(msgText));
    return dispatch(deletionSuccess());
  };
};

//ИЗМЕНЕНИЕ ВИДИМОСТИ РОДИТЕЛЬСКОГО ВОПРОСА
const startVisibilityChange = () => ({
  type: QUESTION_VISIBILITY_CHANGE_START
});

const visibilityChangeSuccess = status => ({
  type: QUESTION_VISIBILITY_CHANGED_SUCCESSFULLY,
  payload: { status },
});

const visibilityChangeFailure = () => ({
  type: QUESTION_VISIBILITY_CHANGE_FAILED,
});

export const changeQuestionVisibilityAsync = (status, questionId) => {
  return async (dispatch) => {
    dispatch(startVisibilityChange());
    await dispatch(checkAndRenewTokens());
    const data = { is_visible: status };
    try {
      const accessToken = localStorage.getItem("accessToken"); 
      await changeQuestionVisibility(accessToken, data, questionId);
    } catch (err) {
      dispatch(showErrorMessage("Ошибка при изменении видимости вопроса"));
      dispatch(checkTokenError(err));
      return dispatch(visibilityChangeFailure());
    }
    let msgText = 'Вопрос скрыт от пользователей';
    if (status) msgText = 'Вопрос доступен пользователям';
    dispatch(showSuccessMessage(msgText));
    return dispatch(visibilityChangeSuccess(status));
  };
};

//ИЗМЕНЕНИЕ ВИДИМОСТИ ПОДВОПРОСА
const startSubQVisibilityChange = () => ({
  type: SUBQUESTION_VISIBILITY_CHANGE_START
});

const subQVisibilityChangeSuccess = (status, questionIndex) => ({
  type: SUBQUESTION_VISIBILITY_CHANGED_SUCCESSFULLY,
  payload: { status, questionIndex },
});

const subQVisibilityChangeFailure = () => ({
  type: SUBQUESTION_VISIBILITY_CHANGE_FAILED,
});

export const changeSubquestionVisibilityAsync = (status, questionId, questionIndex) => { 
  return async (dispatch) => {
    dispatch(startSubQVisibilityChange());
    await dispatch(checkAndRenewTokens());
    const data = { is_visible: status };
    try {
      const accessToken = localStorage.getItem("accessToken"); 
      await changeQuestionVisibility(accessToken, data, questionId);
    } catch (err) {
      dispatch(showErrorMessage("Ошибка при изменении видимости вопроса"));
      dispatch(checkTokenError(err));
      return dispatch(subQVisibilityChangeFailure());
    }
    let msgText = 'Подвопрос скрыт от пользователей';
    if (status) msgText = 'Подвопрос доступен пользователям';
    dispatch(showSuccessMessage(msgText));
    return dispatch(subQVisibilityChangeSuccess(status, questionIndex));
  };
};

//ПЕРЕМЕЩЕНИЕ ПОДВОПРОСА ПО СПИСКУ ПОДВОПРОСОВ
const startSorting = () => ({
  type: CHILDREN_SORTING_START
});

const sortingSuccess = () => ({
  type: CHILDREN_SORTED_SUCCESSFULLY,
});

const sortingFailure = () => ({
  type: CHILDREN_SORTING_FAILED,
});

export const sortChildrenAsync = ({oldIndex, newIndex}) => {
  return async (dispatch, getState) => {
    dispatch(startSorting());
    await dispatch(checkAndRenewTokens());

    //Сформируем массив IDs
    const currentState = getState();
    const currentQuestion = currentState.questionInfo.question;
    const idsArr = currentQuestion.children.map((question, i) => { return question.id });
    //Отсортируем массив
    const itemId = idsArr.splice(oldIndex, 1);
    idsArr.splice(newIndex, 0, itemId[0]);
    const data = { order_data: idsArr };

    try {
      const accessToken = localStorage.getItem("accessToken");
      await sortQuestions(accessToken, data);
    } catch (err) {
      dispatch(showErrorMessage("Ошибка при сортировке вопросов"));
      dispatch(checkTokenError(err));
      return dispatch(sortingFailure());
    }
    dispatch(sortingSuccess());
    //После перемещения заново загрузим информацию о вопросе
    return dispatch(getQuestionInfoAsync(currentQuestion.id));
  };
};
